import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import { selectHarvestSchemaExists } from 'services/schemas/selectors';

export interface OwnProps {
    children: React.ReactElement;
    FallbackComponent?: React.ReactElement;
}

interface ConnectedProps {
    harvestSchemaExists?: boolean;
}

type Props = OwnProps & ConnectedProps;

/**
 * A component to wrap around content only visible to organisations that have a the harvest feature enabled.
 */
export class HarvestSchemaExistsGate extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, FallbackComponent, harvestSchemaExists } = this.props;
        if (!harvestSchemaExists) {
            return FallbackComponent || null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    harvestSchemaExists: selectHarvestSchemaExists
});

export default connect(mapStateToProps)(HarvestSchemaExistsGate);
